import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@vionixasia/shared-components";

export default function AdminRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <p className="text-slate-500 text-sm">Loading...</p>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  const isAdmin =
    user.isAdmin === true ||
    user.role === "admin" ||
    user.role === "superadmin";

  if (!isAdmin) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-white gap-3">
        <h2 className="text-2xl font-bold text-slate-800">Access Denied</h2>
        <p className="text-slate-500 text-sm">You do not have permission to access this page.</p>
        <a href="/" className="text-blue-600 text-sm underline">Back to Home</a>
      </div>
    );
  }

  return children;
}
